/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberDinghyBookingChangeController', MemberDinghyBookingChangeController);

    MemberDinghyBookingChangeController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'ProfileService', '$http', '$sce', 'AlertService', 'entity'];

    function MemberDinghyBookingChangeController ($timeout, $scope, $state, $uibModalInstance, ProfileService, $http, $sce, AlertService, entity) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.booking = {};
        vm.booking.id = vm.dinghyEvent.bookingId;
        vm.oldBookingStatus = vm.dinghyEvent.bookingStatus;
        vm.booking.bookingStatus = vm.oldBookingStatus === 'zurueckgetreten' ? 'angemeldet' : 'zurueckgetreten';
        vm.isCancel = vm.booking.bookingStatus !== 'angemeldet'
        vm.booking.dinghy = vm.dinghyEvent.bookedDinghy;
        vm.booking.commentDinghy = vm.dinghyEvent.commentDinghy;
        var editDateCheck = new Date();
        editDateCheck.setDate(editDateCheck.getDate() - 1);
        if (vm.oldBookingStatus === 'abgelehnt' || vm.dinghyEvent.fromDate < editDateCheck) {
            clear();
        }

        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.put('api/member/dinghy-bookings/', vm.booking).then(function(response) {
                vm.error = null;
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }, function() {
                vm.isSaving = false;
            });
        }
    }
})();
